export const cleanEmail = (email: string): string => {
  return email.replace(/ /g, "");
};
